export enum NotificationType {
    DELETE_ACCOUNT_TASK_RECEIVED = 'DELETE_ACCOUNT_TASK_RECEIVED',
    ORDER_FAILED = 'ORDER_FAILED',
    ORDER_FINISHED = 'ORDER_FINISHED'
}
